<div class="grand-parent">
    <div class="parent" #slider>
        @if(initialized && dto){
            <ng-container>

                <div class="wf-top-navigation shadow-1">
                    <div class="col-12">
                        <p-toolbar>

                            <div class="flex justify-content-between align-items-center w-full">
                                <div class="pl-8 wf-process-title">

                                    <div class="flex align-items-center gap-4">
                                        <span>{{ dto.name }}</span>
                                        <!--                                    <span pButton class="flex align-items-center gap-2 p-button-text"-->
                                        <!--                                          (click)="menu.toggle($event)">-->
                                        <!--                             <i class="fa-regular fa-ellipsis"></i>-->
                                        <!--                        </span>-->
                                    </div>

                                </div>
                                <div class="p-toolbar-group-end gap-4 pr-2">

                                    <p-button
                                            styleClass="p-button-success"
                                            [icon]="showProcessStart ? 'fa-regular fa-xmark' : 'fa-solid fa-play'"
                                            (onClick)="showProcessStart = !showProcessStart"
                                            [disabled]="busy"
                                    ></p-button>

                                    <p-button icon="fa-solid fa-search" label="Prozesse anzeigen"
                                              (click)="onShowProcess()" [disabled]="busy"></p-button>

                                    @if(!dto.steps || !dto.steps.length){
                                        <p-button icon="fa-solid fa-plus"
                                                  label="Schritt erstellen"
                                                  (click)="onCreateStep()" [disabled]="busy">

                                        </p-button>
                                    }


                                    <p-button
                                            icon="fa-solid fa-plus"
                                            label="Felder erstellen"
                                            [badge]="this.dto?.fields?.length.toString()" styleClass="mr-2"
                                            (click)="onCreateFields('Field')" [disabled]="busy"></p-button>

                                    <p-button
                                            icon="fa-solid fa-plus"
                                            label="Prozessergebnis"
                                            [badge]="this.dto?.results?.length.toString()"
                                            (click)="onCreateFields('Result')" [disabled]="busy"></p-button>

                                    @if(processSteps){
                                        <p-toggle-switch [(ngModel)]="showRuntimeInfo"
                                                         (onChange)="processRuntimeInfo()"></p-toggle-switch>
                                    }



                                </div>
                            </div>


                        </p-toolbar>
                    </div>

                </div>

                <div class="child dotted-background">

                    <div class="grid">
                        @if (showProcessStart){
                            <div class="col-12 mt-5">
                                <div style="width: 95vw">
                                    @if(showProcessStart)
                                    {
                                        <mvs-wf-process-start
                                                [processTypeId]="dto.id"
                                                [onStartNavigate]="true"
                                                (onProcessCreated)="showProcessStart = false"
                                                [heading]="false"
                                        ></mvs-wf-process-start>
                                    }

                                </div>
                            </div>
                        }

                        <div class="col-12">

                            <div class="main-wf-section">
                                <div class="wf-section-view">
                                    @if(!activityDragStarted){
                                        <div class="flex"
                                             (mouseleave)="activityDragStarted = false"
                                             cdkDropList
                                             cdkDropListOrientation="horizontal"
                                             [cdkDropListData]="processSteps"
                                             [cdkDropListConnectedTo]="['processStepDropList']"
                                             (cdkDropListDropped)="drop($event)">

                                            @for (step of processSteps; track step; let idx = $index, last = $last) {
                                                <ng-container>

                                                    <div class="wf-add-step-hov">
                                                        <p-button icon="fa-solid fa-plus" class="wf-add-step-button"
                                                                  pTooltip="Schritt erstellen"
                                                                  tooltipPosition="bottom"
                                                                  (click)="onCreateStepInBetween(processSteps,idx)"></p-button>
                                                    </div>

                                                    <div class="wf-step-card"
                                                         [ngClass]="{'wf-hover-section': wfHoverStep === step.name}"
                                                         cdkDrag>

                                                        <ng-container [ngTemplateOutlet]="stepItems"
                                                                      [ngTemplateOutletContext]="{step:step, idx:idx, last:last}"></ng-container>
                                                    </div>

                                                    @if(last){
                                                        <div  class="wf-step-card cursor-pointer ml-6"
                                                              (click)="onCreateStepInBetween(processSteps,idx+1)">
                                                            <div class="flex justify-content-center align-items-center w-full gap-2">

                                                                <!--                                                <p-button icon="fa-light fa-plus"-->
                                                                <!--                                                          styleClass="p-button-rounded"></p-button>-->
                                                                <div class="wf-process-config-create-last">
                                                                    <i class="fa-light fa-plus"></i>
                                                                </div>

                                                                <span>Neuen Schritt erstellen</span>
                                                            </div>
                                                        </div>
                                                    }



                                                </ng-container>
                                            }


                                        </div>
                                    }

                                    @if(activityDragStarted){
                                        <div
                                             (mouseleave)="activityDragStarted = false"
                                             class="flex"
                                        >
                                            @for (step of processSteps; track step; let idx = $index, last = $last) {
                                                <ng-container>

                                                    <div class="wf-add-step-hov">
                                                        <p-button icon="fa-solid fa-plus" class="wf-add-step-button"
                                                                  pTooltip="Schritt erstellen"
                                                                  tooltipPosition="bottom"
                                                                  (click)="onCreateStepInBetween(processSteps,idx)"></p-button>
                                                    </div>

                                                    <div class="wf-step-card"
                                                         [ngClass]="{'wf-hover-section': wfHoverStep === step.name}"
                                                         cdkDrag>

                                                        <ng-container [ngTemplateOutlet]="stepItems"
                                                                      [ngTemplateOutletContext]="{step:step, idx:idx, last:last}"></ng-container>
                                                    </div>

                                                    @if(last){
                                                        <div class="wf-step-card cursor-pointer ml-6">
                                                            <div class="flex justify-content-center align-items-center w-full gap-2"
                                                                 (click)="onCreateStepInBetween(processSteps,idx+1)">
                                                                <div class="wf-process-config-create-last">
                                                                    <i class="fa-light fa-plus"></i>
                                                                </div>
                                                                <span>Neuen Schritt erstellen</span>
                                                            </div>
                                                        </div>
                                                    }



                                                </ng-container>
                                            }


                                        </div>
                                    }

                                </div>
                            </div>

                        </div>
                    </div>
                </div>


            </ng-container>
        }


    </div>
</div>

<!-- ******************* dialog box ******************* -->

<p-dialog
        [header]="dialogHeaderLabel"
        [(visible)]="visible"
        [style]="{width: '60vw', height: '80vh'}"
        (onHide)="onDialogHide($event)"
>

    @if (
            (tabName != 'Activity' && !selectedObject) ||
            (tabName != 'Activity' && selectedObject) ||
            (tabName == 'Activity' && !selectedObject)
         )
        {
            <ng-container   [ngTemplateOutlet]="formObjectTemplate"></ng-container>
        }

    @if(tabName === 'Activity' && selectedObject){
        <p-tabs [(value)]="tabIndex" (valueChange)="changeTab($event)">
            <p-tablist>
                <p-tab [value]="0">{{ tabName }}</p-tab>
                <p-tab [value]="1">Formular-Standardwerte</p-tab>
                <p-tab [value]="2">Bindung</p-tab>
            </p-tablist>

            <p-tabpanels>
                <!-- Tab 0: Activity -->
                <p-tabpanel [value]="0">
                    <ng-container [ngTemplateOutlet]="formObjectTemplate"></ng-container>
                </p-tabpanel>

                <!-- Tab 1: Form Defaults -->
                <p-tabpanel [value]="1">
                    <div class="grid">
                        <div class="col-4">
                            <div class="mvs-widget">
                                @if(widgetDefaultFieldsTable){
                                    <mvs-widget
                                            [widgetData]="widgetDefaultFieldsTable"
                                            (onObjectSelect)="onDefaultFieldSelect($event)">
                                    </mvs-widget>
                                }

                            </div>
                        </div>

                        <div class="col-8">
                            @if (stepActivityFormDefaultId){
                                <div>
                                    <p-button label="Neu" (click)="stepActivityFormDefaultId = 0; resetForm()"></p-button>
                                    <br />
                                </div>
                            }

                            @if (objectFormWidget && tabIndex === 1){
                                <mvs-widget
                                        [widgetData]="objectFormWidget"
                                        (onChangedObject)="onChangeObject($event)">
                                </mvs-widget>
                            }

                        </div>
                    </div>
                </p-tabpanel>

                <!-- Tab 2: Binding -->
                <p-tabpanel [value]="2">
                    <div class="grid">
                        <div class="col-4">
                            <div class="mvs-widget">
                                @if(widgetBindingFieldsTable){
                                    <mvs-widget
                                            [widgetData]="widgetBindingFieldsTable"
                                            (onObjectSelect)="onBindingSelect($event)">
                                    </mvs-widget>
                                }

                            </div>
                        </div>

                        <div class="col-8">
                            @if(stepActivityBindingId){
                                <div>
                                    <p-button label="Neu" (click)="stepActivityBindingId = 0; resetForm()"></p-button>
                                    <br />
                                </div>
                            }

                            @if(objectFormWidget && tabIndex === 2){
                                <mvs-widget
                                        [widgetData]="objectFormWidget"
                                        (onChangedObject)="onChangeObject($event)">
                                </mvs-widget>
                            }

                        </div>
                    </div>
                </p-tabpanel>
            </p-tabpanels>
        </p-tabs>
    }



</p-dialog>


<ng-template #formObjectTemplate>
    <div class="grid">
        @if (widgetFieldsTable){
            <div class="col-4">
                <div class="mvs-widget">

                    <!-- ******************* list ******************* -->

                    <mvs-widget
                            [widgetData]="widgetFieldsTable"
                            (onObjectSelect)="onFieldSelect($event)"
                    ></mvs-widget>
                </div>
            </div>
        }


        <div [ngClass]="widgetFieldsTable ? 'col-8' : 'col-12'">
            @if (selectObjectIdentifier?.objectType == 'wf.WfProcessTypeField' && selectObjectIdentifier.objectId){
                <div>

                    <p-button
                            label="Neu"
                            (click)="onCreateFields('Field')"
                    ></p-button>
                    <br>
                </div>
            }

            @if(selectObjectIdentifier?.objectType == 'wf.WfProcessTypeResult' && selectObjectIdentifier.objectId){
                <div>

                    <p-button
                            label="Neu"
                            (click)="onCreateFields('Result')"
                    ></p-button>
                    <br>
                </div>
            }


            <!-- ******************* form ******************* -->

            @if(objectFormWidget){
                <mvs-widget
                            [widgetData]="objectFormWidget"
                            (onChangedObject)="onChangeObject($event)"
                >
                </mvs-widget>
            }


        </div>

    </div>
</ng-template>


<!--[viewportHeight]="160"-->
<!--[menuWidth]="175"-->
<p-tiered-menu
    #menu
    [model]="configurationItems"
    [popup]="true"
    class="wf-slide-menu"
>
</p-tiered-menu>


<!--[viewportHeight]="160"-->
<!--[menuWidth]="175"-->
<p-tiered-menu
    #nextStepMenu
    [model]="nextStepsConfigurationItems"
    [popup]="true"
    class="wf-slide-menu"
    (onHide)="isActivityStepsOverlay=false"
>
</p-tiered-menu>

<ng-template #stepItems let-step='step' , let-idx='idx' , let-last='last'>


    <!-- Container for displaying workflow steps -->
    <ng-container>
        <div class="w-full flex flex-column gap-3"
             cdkDropList
             [cdkDropListSortingDisabled]="true"
             [cdkDropListData]="step.nextSteps"
             [id]="'stepDropList_' + idx"
             (cdkDropListDropped)="onDrop($event, step)"
             [cdkDropListConnectedTo]="getStepConnectedLists()"
        >

            <!-- Display each workflow step -->

            <div class="w-full"
                 (mouseenter)="activityDragStarted = false">
                <div class="flex justify-content-between align-items-center w-full">
                    <div class="flex align-items-center gap-2">

                        <!-- Display step index badge -->

                        <p-badge [value]="(idx + 1).toString()"></p-badge>
                        <div class="flex flex-column">

                            <!-- Display step name -->

                            <span class="pointer text-left step-name-font"
                                  (click)="onStepSelect(step)"
                                  [class]="selectedObject?.id == step.id ? selectedObject['_class'] : ''">
                                                    {{ step.name }}</span>
                        </div>
                    </div>

                    <!-- Display ellipsis icon for additional options -->

                    <i class="fa-regular fa-ellipsis pointer"
                       (click)="menu.toggle($event); selectedStep = step"></i>
                </div>
                <div [style]="{'padding-left':'27px'}">

                    <!-- Display workflow step flow type -->

                    <span class="text-left wf-process-config-flow-type-font"> {{ flowType[step.flowType] }} </span>
                </div>
            </div>

            <!--************************ ACTIVITIES ************************-->

            <!-- Activities section within the workflow step -->

            <ng-container>
                <div class="w-full flex flex-column gap-2"
                     cdkDropList
                     [cdkDropListSortingDisabled]="true"
                     [cdkDropListData]="step.activities"
                     [id]="'activityDropList_' + idx"
                     (cdkDropListDropped)="onDrop($event, step)"
                     [cdkDropListConnectedTo]="getActivityConnectedLists()">

                    <!-- Display each activity within the workflow step -->
                    @for (activity of step.activities; track $index) {
                        <ng-container>

                            <!--************************ MAIN ACTIVITY ************************-->
                            @if (activity.processing == 1 || activity.processing == 2){
                                <ng-container>

                                    <div class="wf-step-box relative hover:surface-hover"
                                         (mouseenter)="activityDragStarted = true"
                                         cdkDrag
                                         [cdkDragData]="activity"
                                         (cdkDragStarted)="onDragActivityStarted($event, activity)"
                                         (cdkDragEntered)="onActivityDragEntered($event)"
                                         [class]="selectedObject?.id == activity.id ? selectedObject['_class'] : ''"
                                         (click)="onActivitySelect(activity,step)">
                                        <!--                                            <div class="flex flex-column align-items-start">-->

                                        <div class="flex w-full justify-content-between">
                                            <p-tag
                                                    [style]="
                                                                {
                                                                  'display': 'flex',
                                                                  'padding': '4px 8px',
                                                                  'justify-content': 'center',
                                                                  'align-items': 'center',
                                                                  'gap': '4px',
                                                                  'border-radius': '32px',
                                                                  'font-weight': '400'
                                                                }"
                                                    [icon]="getActivityImage(activity.activityType)"
                                                    severity="success"
                                                    [value]="getActivityField(activity.activityType)"
                                                    [rounded]="true"></p-tag>

                                            @if (showRuntimeInfo){
                                                <p-badge severity="danger"
                                                         [value]="activity['processTypeStepActivity_count'] ? activity['processTypeStepActivity_count'] : 0"></p-badge>
                                            }

                                        </div>

                                        @if (activity.description){
                                            <div
                                                    class="wf-description-ellipses wf-process-config-description-font"
                                                    [innerHTML]="activity.description | mvsSavePipe:'html'">
                                            </div>
                                        }

                                        @if (activity.processing==2){
                                            <div
                                                    class="wf-process-config-timer-icon">
                                                <div
                                                        class="wf-process-config-timer-icon-wrapper">
                                                    <i class="fa-regular fa-layer-group"></i>
                                                </div>
                                            </div>
                                        }

                                        @if (step.nextSteps && step.nextSteps.length){
                                            <div class="w-full">
                                                @if(!activity.processTypeStepNextDtoId){
                                                    <div class="w-full wf-process-config-description-font flex justify-content-between">
                                                        <div class="flex gap-2">
                                                            <i class="fa-solid fa-angles-right"></i>
                                                            <span>Nächsten Schritt hinzufügen</span>
                                                        </div>
                                                        <i class="fa-regular fa-circle-plus hover:text-primary"
                                                           (click)="openStepsMenu(nextStepMenu,step.nextSteps,activity, $event)"></i>
                                                    </div>
                                                }

                                                @if(activity.processTypeStepNextDtoId){
                                                    <div class="wf-process-config-activity-step w-full wf-process-config-description-font"
                                                    >
                                                        <i class="fa-solid fa-angles-right"></i>
                                                        <span>{{ activity.processTypeStepNextDtoName }}</span>
                                                        <i class="fa-regular fa-circle-minus hover:text-primary"
                                                           (click)="openStepsMenu(nextStepMenu,step.nextSteps,activity, $event, true)"></i>
                                                    </div>
                                                }


                                            </div>
                                        }

                                    </div>

                                </ng-container>
                            }


                        </ng-container>
                    }


                    <!-- Display message for missing Main Activity -->

                    @if (!handleMainActivityMissing(step.activities)){
                        <ng-container>
                            <div class="wf-step-box wf-selected-red-box hover:surface-hover"
                                 (click)="onCreateActivity(step)">
                                <div class="flex justify-content-center align-items-center w-full gap-2">
                                    <i class="fa-regular fa-circle-info wf-selected-red-box-icon"></i>
                                    <span class="wf-selected-red-box-text">
                                    Hauptaktivität fehlt
                                </span>
                                </div>
                            </div>
                        </ng-container>
                    }


                    <div class="wf-step-box wf-process-config-wf-step">
                        @for (activity of step.activities; track $index) {
                            <ng-container>

                                <!--************************ OPTIONAL ACTIVITY ************************-->
                                @if (activity.processing == 0 || activity.processing == 3){
                                    <ng-container>

                                        <div class="w-full">


                                            <div
                                                    (mouseenter)="activityDragStarted = true"
                                                    cdkDrag
                                                    [cdkDragData]="activity"
                                                    (cdkDragStarted)="onDragActivityStarted($event, activity)"
                                                    (cdkDragEntered)="onActivityDragEntered($event)"
                                                    [class]="selectedObject?.id == activity.id ? selectedObject['_class'] : ''"
                                                    (click)="onActivitySelect(activity,step)">

                                                <div class="wf-step-box border-dashed relative w-full hover:surface-hover">
                                                    <div class="flex w-full justify-content-between">
                                                        <p-tag
                                                                [style]="
                                                                {
                                                                  'display': 'flex',
                                                                  'padding': '4px 8px',
                                                                  'justify-content': 'center',
                                                                  'align-items': 'center',
                                                                  'gap': '4px',
                                                                  'border-radius': '32px',
                                                                  'font-weight': '400'
                                                                }"
                                                                [icon]="getActivityImage(activity.activityType)"
                                                                [value]="getActivityField(activity.activityType)"
                                                                [rounded]="true"></p-tag>

                                                        @if (showRuntimeInfo){
                                                            <p-badge severity="danger"
                                                                     [value]="activity['processTypeStepActivity_count'] ? activity['processTypeStepActivity_count'] : 0"></p-badge>
                                                        }

                                                    </div>

                                                    @if(activity.description){
                                                        <div  class="wf-description-ellipses wf-process-config-description-font"
                                                              [innerHTML]="activity.description | mvsSavePipe:'html'">
                                                        </div>
                                                    }


                                                    @if (activity.processing==3){
                                                        <div
                                                                class="flex justify-content-end w-full wf-description-ellipses wf-process-config-description-font">
                                                            <div> {{ activityWaitTimeFrequency[activity['waitTimeFrequency']].label }}
                                                                : {{ activity['waitTimeFrequencyAmount'] }}
                                                            </div>
                                                        </div>
                                                    }

                                                    @if (activity.processing==3){
                                                        <div
                                                                class="wf-process-config-timer-icon">
                                                            <div
                                                                    class="wf-process-config-timer-icon-wrapper"
                                                                    [pTooltip]="activity['waitTimeFrequencyAmount'] + ' ' + activityWaitTimeFrequency[activity['waitTimeFrequency']].label">
                                                                <i class="fa-solid fa-timer"></i>
                                                            </div>
                                                        </div>
                                                    }


                                                    @if (step.nextSteps && step.nextSteps.length) {
                                                        <div class="w-full">
                                                            @if(!activity.processTypeStepNextDtoId){
                                                                <div class="w-full wf-process-config-description-font flex justify-content-between">
                                                                    <div class="flex gap-2">
                                                                        <i class="fa-solid fa-angles-right"></i>
                                                                        <span>Nächsten Schritt hinzufügen</span>
                                                                    </div>
                                                                    <i class="fa-regular fa-circle-plus hover:text-primary"
                                                                       (click)="openStepsMenu(nextStepMenu,step.nextSteps,activity, $event)"></i>
                                                                </div>
                                                            }

                                                            @if (activity.processTypeStepNextDtoId) {
                                                                <div class="wf-process-config-activity-step w-full wf-process-config-description-font"
                                                                >
                                                                    <i class="fa-solid fa-angles-right"></i>
                                                                    <span>{{ activity.processTypeStepNextDtoName }}</span>
                                                                    <i class="fa-regular fa-circle-minus hover:text-primary"
                                                                       (click)="openStepsMenu(nextStepMenu,step.nextSteps,activity, $event, true)"></i>
                                                                </div>
                                                            }

                                                        </div>
                                                    }


                                                </div>
                                            </div>


                                        </div>

                                    </ng-container>
                                }

                            </ng-container>
                        }

                        <ng-container>
                            <div class="wf-step-box border-dashed"
                                 [ngClass]="{'wf-process-config-wf-missing-optional':handleOptionalActivityMissing(step.activities)}"
                                 (click)="onCreateActivity(step)">
                                <div class="flex justify-content-center align-items-center gap-2 w-full">
                                    <i class="fa-regular fa-circle-plus hover:text-primary"></i>
                                    <span> Optionale Aktivität hinzufügen </span>
                                </div>
                            </div>
                        </ng-container>

                    </div>
                </div>
            </ng-container>


            <!--************************ HINTS ************************-->

            <!-- Display hints associated with the workflow step -->
            @for (hint of step.stepHints; track $index) {
                <ng-container>

                    <div class="wf-step-box hover:surface-hover"
                         [class]="selectedObject?.id == hint.id ? selectedObject['_class'] : ''"
                         (click)="onHintSelect(hint)">

                        <p-tag
                                [style]="
                                                                {
                                                                  'display': 'flex',
                                                                  'padding': '4px 8px',
                                                                  'justify-content': 'center',
                                                                  'align-items': 'center',
                                                                  'gap': '4px',
                                                                  'border-radius': '32px',
                                                                  'font-weight': '400'
                                                                }"
                                icon="fa-regular fa-circle-info"
                                severity="info"
                                [value]="hint.hintTypeDtoName + ' ' + hint.priority"
                                [rounded]="true"></p-tag>
                        @if (hint.description) {
                            <span
                                    class="wf-description-ellipses wf-process-config-description-font"
                                    [innerHTML]="hint.description | mvsSavePipe:'html'">
                        </span>
                        }


                    </div>

                </ng-container>
            }


            <!--************************ STEPS ************************-->

            <!-- Display Next Steps section -->

            <ng-container>

                <div class="wf-step-box">
                    <div class="flex justify-content-between align-items-center w-full">
                        <div class="flex gap-2">
                            <i class="fa-solid fa-angles-right"></i>
                            <span class="wf-process-config-next-step-font">Nächste Schritte</span>
                        </div>
                        <div class="flex gap-3 align-items-center">
                            <i class="fa-light fa-circle-plus hover:text-primary"
                               (click)="createNextStep(step)"
                               pTooltip="Nächsten Schritt hinzufügen"
                               tooltipPosition="top"></i>

                            <div
                                    (mouseenter)="stepDragStarted = true; activityDragStarted = true"
                                    cdkDrag
                                    [cdkDragData]="step"
                                    (cdkDragStarted)="onDragNextStepStarted($event, step)"
                                    (cdkDragEntered)="onStepDragEntered($event)"
                                    pTooltip="Zum nächsten Schritt ziehen"
                                    tooltipPosition="top">
                                <i class="fa-regular fa-up-down-left-right hover:text-primary"></i>
                                <!--                            <i class="fa-light fa-circle-plus hover:text-primary"></i>-->
                            </div>
                        </div>
                    </div>

                    <!-- Display each Next Step -->
                    @for (nextStep of step.nextSteps; track $index) {
                        <ng-container>

                            <div class="wf-step-box p-2 border-dashed hover:surface-hover"
                                 [class]="selectedObject?.id == nextStep.id ? selectedObject['_class'] : ''"
                                 (mouseover)="onParentWfHover(nextStep.nextProcessTypeStepDtoName)"
                                 (mouseout)=" clearHoveredWf()"
                                 (click)="onNextStepSelect(nextStep)">

                                <div class="w-full flex justify-content-center">
                                    @if (nextStep?.nextProcessTypeStepDtoName) {
                                        <span class="next-step-font">{{ nextStep?.nextProcessTypeStepDtoName }}</span>
                                    }
                                    @if (!nextStep?.nextProcessTypeStepDtoName) {
                                        <span class="next-step-font"><i
                                                class="fa-solid fa-flag-checkered"></i></span>
                                    }

                                </div>

                            </div>

                        </ng-container>
                    }


                </div>

            </ng-container>

            <!-- Display runtime info badge -->

            @if (showRuntimeInfo) {
                <div>
                    <p-badge severity="danger"
                             [value]="step['processStepsCount'] ? step['processStepsCount'] : 0"></p-badge>
                </div>
            }



        </div>
    </ng-container>

</ng-template>
